import { FC, useState } from 'react';

import logger from '@eneco/common/log';
import { stripAccolades } from '@eneco/common/string';
import { postEnecoBeXapiSiteApiV1FormsByFormName } from '@eneco/dc-be/client';
import { GenericFormRendering } from '@sitecore/types/manual/GenericForm';
import { SubmitHandler } from 'react-hook-form';

import CommonGenericForm from './CommonGenericForm';
import { ErrorType, FormValues } from './util';

const EloquaForm: FC<GenericFormRendering> = ({ fields, placeholders }) => {
  const {
    senderIdOption: { value: senderId },
  } = fields;

  const [errorType, setErrorType] = useState<ErrorType | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const submitForm: SubmitHandler<FormValues> = async values => {
    setIsSubmitting(true);
    const data = await postEnecoBeXapiSiteApiV1FormsByFormName({
      body: values,
      path: { formName: stripAccolades(senderId) },
    }).then(res => {
      setIsSubmitting(false);
      return res;
    });
    if (data.response.ok) {
      setIsSuccess(true);
    } else {
      setErrorType('generic');
      logger.error('Wxd7AY', 'Failed to submit form', { data });
    }
  };

  return (
    <CommonGenericForm
      fields={fields}
      placeholder={placeholders['jss-eloqua-form']}
      placeholderName="jss-eloqua-form"
      submitForm={submitForm}
      isSubmitting={isSubmitting}
      errorType={errorType}
      isSuccess={isSuccess}
    />
  );
};

export default EloquaForm;
